import { useQuery } from '@tanstack/react-query';
import { useAppContext } from '@/context/AppContext';
import { useToken } from '@/lib/useToken';
import { apiFetch } from '@/lib/api';
import { BUSINESS_UNITS } from '@/data/businessUnits';
import type { BusinessUnit } from '@/data/businessUnits';

interface UseBusinessUnitsResult {
  data: readonly BusinessUnit[];
  isLoading: boolean;
}

export function useBusinessUnits(): UseBusinessUnitsResult {
  const { mockupMode, currentOrg } = useAppContext();
  const getToken = useToken();
  const orgId = currentOrg.id;

  const query = useQuery({
    queryKey: ['businessUnits', orgId],
    queryFn: async () => {
      const token = await getToken();
      const res = await apiFetch<{
        businessUnits: Array<{ id: string; name: string }>;
      }>(`/api/v1/orgs/${orgId}/business-units`, token);
      return res.businessUnits.map(
        (bu): BusinessUnit => ({
          id: bu.id,
          name: bu.name,
        }),
      );
    },
    enabled: !mockupMode && !!orgId,
  });

  if (mockupMode) return { data: BUSINESS_UNITS, isLoading: false };
  return { data: query.data ?? [], isLoading: query.isLoading };
}
